module.exports = __webpack_public_path__ + "img/userD09.0e835adb.jpg";